import { useScreenClass } from 'hooks'
import { Query } from 'hooks/query-params'
import { Grid } from '~ui'
import DesktopSide from './desktop-side'
import MobileSide from './mobile-side'
import { Item } from './filters'

export type categoriesProps = {
  value: string
  label: string
  position?: number
}

export type FilterStateType = Pick<Query, 'categoryIds' | 'countries' | 'states' | 'query'>

export interface FiltersProps {
  items: Item[]
  isOpen?: boolean
  searchable?: boolean
}

type FiltersContainerProps = {
  searchPlaceholder: string
  buttonTitle?: string
  isOpen?: boolean
  filterOptions: Item[]
}

const FiltersContainer = ({
  buttonTitle,
  isOpen,
  searchPlaceholder,
  filterOptions,
}: FiltersContainerProps) => {
  const { isDesktop } = useScreenClass()

  return (
    <Grid padding="1.5rem" paddingBottom="0">
      {isDesktop ? (
        <DesktopSide items={filterOptions} placeholder={searchPlaceholder} isOpen={isOpen} />
      ) : (
        <MobileSide
          items={filterOptions}
          title={buttonTitle}
          placeholder={searchPlaceholder}
          isOpen={isOpen}
        />
      )}
    </Grid>
  )
}

export default FiltersContainer
